import React, { useMemo, useState } from "react";
import { toast } from "sonner";
import { pick } from "./GameShell";

const Match = ({ game, level, lang, onFinish }) => {
  const lvl = game.levels[level - 1] || {};
  const pairs = lvl.pairs || game.data.pairs;
  const pointsPerLevel = lvl.points || game.points;

  const rightOrder = useMemo(
    () => pairs.map((_, i) => i).sort(() => Math.random() - 0.5),
    [pairs]
  );
  const [leftPick, setLeftPick] = useState(null);
  const [solved, setSolved] = useState(new Set());
  const [errors, setErrors] = useState(0);

  const tryMatch = (rightIdx) => {
    if (leftPick === null) return;
    if (leftPick === rightIdx) {
      const nx = new Set(solved);
      nx.add(rightIdx);
      setSolved(nx);
      setLeftPick(null);
      if (nx.size === pairs.length) {
        const earned = Math.max(0, pointsPerLevel - errors * 5);
        onFinish({ score: pairs.length - errors, points: earned, total: pairs.length });
      }
    } else {
      setErrors((e) => e + 1);
      toast.error(lang === "es" ? "Casi." : "Not quite.");
      setLeftPick(null);
    }
  };

  return (
    <div data-testid={`game-match-${game.id}`}>
      <p className="text-xs bs-muted mb-3">
        {lang === "es" ? "Aciertos" : "Score"}: {pairs.length - errors}
      </p>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-2">
          {pairs.map((p, idx) => (
            <button
              key={`l-${idx}`}
              onClick={() => !solved.has(idx) && setLeftPick(idx)}
              disabled={solved.has(idx)}
              data-testid={`match-left-${idx}`}
              className={`w-full text-left p-3 rounded-2xl text-sm font-semibold transition-colors ${
                solved.has(idx)
                  ? "bg-emerald-500/15 border border-emerald-400/50 text-white/80"
                  : leftPick === idx
                  ? "bg-amber-400/25 border border-amber-400 text-white"
                  : "bg-white/5 border border-white/10 text-white hover:bg-white/10"
              }`}
            >
              {pick(lang, p.a)}
            </button>
          ))}
        </div>
        <div className="space-y-2">
          {rightOrder.map((rIdx) => (
            <button
              key={`r-${rIdx}`}
              onClick={() => tryMatch(rIdx)}
              disabled={solved.has(rIdx) || leftPick === null}
              data-testid={`match-right-${rIdx}`}
              className={`w-full text-left p-3 rounded-2xl text-sm font-semibold transition-colors ${
                solved.has(rIdx)
                  ? "bg-emerald-500/15 border border-emerald-400/50 text-white/80"
                  : "bg-white/5 border border-white/10 text-white hover:bg-white/10"
              }`}
            >
              {pick(lang, pairs[rIdx].b)}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Match;
